var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKycIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.3121 0.386719H7.7C3.104 0.386719 0.5 2.99072 0.5 7.58671V20.1868C0.5 24.7827 3.104 27.3867 7.7 27.3867H20.3121C24.908 27.3867 27.5 24.7827 27.5 20.1868V7.58671C27.5 2.99072 24.908 0.386719 20.3121 0.386719Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1571 14.5312C17.4959 14.5312 16.8841 14.7634 16.3987 15.1502C15.7517 15.6636 15.3438 16.4584 15.3438 17.3446C15.3438 17.8721 15.4914 18.3714 15.7517 18.7934C16.237 19.6093 17.1302 20.1579 18.1571 20.1579C18.8674 20.1579 19.5145 19.8977 20.0068 19.4546C20.2249 19.2717 20.4148 19.0466 20.5625 18.7934C20.8227 18.3714 20.9704 17.8721 20.9704 17.3446C20.9704 15.7902 19.7115 14.5312 18.1571 14.5312ZM19.613 17.0421L18.1149 18.4277C18.0164 18.5192 17.8828 18.5684 17.7562 18.5684C17.6226 18.5684 17.4889 18.5192 17.3834 18.4137L16.6871 17.7174C16.4831 17.5134 16.4831 17.1758 16.6871 16.9718C16.8911 16.7678 17.2287 16.7678 17.4326 16.9718L17.7703 17.3094L18.8956 16.2685C19.1066 16.0716 19.4442 16.0856 19.6411 16.2966C19.8381 16.5076 19.824 16.8382 19.613 17.0421Z",
    fill: "#CE2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.3334 20.5094C20.3334 20.7063 20.1787 20.861 19.9818 20.861H7.89854C7.70161 20.861 7.54688 20.7063 7.54688 20.5094C7.54688 17.5976 10.4165 15.2344 13.9402 15.2344C14.6646 15.2344 15.368 15.3328 16.015 15.5227C15.6001 16.0151 15.3469 16.6551 15.3469 17.3444C15.3469 17.8719 15.4945 18.3712 15.7547 18.7932C15.8954 19.0324 16.0783 19.2504 16.2893 19.4333C16.7816 19.8834 17.4358 20.1577 18.1602 20.1577C18.9479 20.1577 19.6583 19.8342 20.1647 19.3137C20.2772 19.6935 20.3334 20.0944 20.3334 20.5094Z",
    fill: "#CE2600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9385 13.8263C15.8807 13.8263 17.4552 12.2518 17.4552 10.3096C17.4552 8.36744 15.8807 6.79297 13.9385 6.79297C11.9963 6.79297 10.4219 8.36744 10.4219 10.3096C10.4219 12.2518 11.9963 13.8263 13.9385 13.8263Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycIcon);
export default __webpack_public_path__ + "static/media/kyc-icon.4a6fbf63c9d7a43ed9e3aa134365dfc0.svg";
export { ForwardRef as ReactComponent };